const API_ROUTES = Object.freeze({
  EXPORT: "/api/export/",
  REPORTS: "/api/reports/",
});

const QUERY_KEYS = Object.freeze({
  EXPORT: "export",
  REPORTS: "reports",
});

export { API_ROUTES, QUERY_KEYS };
